import GetFetch from '../common/GetFetch';

const Fetcher = (dateInit, dateEnd) => {
    const URI = `dashboard/summary/weekly/${dateInit}/${dateEnd}`;

    return GetFetch(URI);
}

export default Fetcher;
